import createDataContext from './createDataContext';

// Deprecated 2022/10/26
// import appearanceQuestions from '../pages/appearanceQuestions';

const LEAGUE_API_URL = `${process.env.REACT_APP_LEAGUE_BASE_API_URL}/recins/jsp/api`;
const LEAGUE_LOGIN_URL = `${process.env.REACT_APP_ACEMUSE_API_URL}/loginSys`;
const LEAGUE_LOGIN_BY_TOKEN_URL = `${process.env.REACT_APP_ACEMUSE_API_URL}/loginSysByToken`;
const ACEMUSE_API_URL = process.env.REACT_APP_ACEMUSE_API_URL;

const postReq = (url, body, callback) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };

  fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      if (callback) {
        callback(data);
      }
    });
};

const postImagesUploadFormData = (
  url,
  {
    orderId,
    idCardFront,
    idCardFrontName,
    idCardBack,
    idCardBackName,
    phoneFront,
    phoneFrontName,
    phoneBack,
    phoneBackName,
    invoice,
    invoiceName,
  },
  callback
) => {
  let body = new FormData();
  body.append('orderId', orderId);
  body.append('idCardFront', idCardFront);
  body.append('idCardFrontName', idCardFrontName);
  body.append('idCardBack', idCardBack);
  body.append('idCardBackName', idCardBackName);
  body.append('phoneFront', phoneFront);
  body.append('phoneFrontName', phoneFrontName);
  body.append('phoneBack', phoneBack);
  body.append('phoneBackName', phoneBackName);
  body.append('invoice', invoice);
  body.append('invoiceName', invoiceName);

  fetch(url, {
    method: 'POST',
    body,
  })
    .then((res) => res.json())
    .then((data) => {
      if (callback) {
        callback(data);
      }
    });
};

const postImagesUploadFormDataExt = (
  url,
  { orderId, phoneFront, phoneFrontName, invoice, invoiceName },
  callback
) => {
  let body = new FormData();
  body.append('orderId', orderId);
  body.append('phoneFront', phoneFront);
  body.append('phoneFrontName', phoneFrontName);
  body.append('invoice', invoice);
  body.append('invoiceName', invoiceName);

  fetch(url, {
    method: 'POST',
    body,
  })
    .then((res) => res.json())
    .then((data) => {
      if (callback) {
        callback(data);
      }
    });
};

const postImageUploadFormData = (url, { orderId, picType, picFile, picName, picUrl }, callback) => {
  let body = new FormData();
  body.append('orderId', orderId);
  body.append('picType', picType);
  body.append('picName', picName);
  body.append('picUrl', picUrl);
  if (picFile) {
    body.append('picFile', picFile);
  }

  fetch(url, {
    method: 'POST',
    body,
  })
    .then((res) => res.json())
    .then((data) => {
      if (callback) {
        callback(data);
      }
    });
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_LOGIN_INFO':
      return { ...state, loginInfo: { ...state.loginInfo, ...action.payload } };
    case 'SET_APP_INFO':
      return {
        ...state,
        app: {
          ...action.payload,
          Env:
            process.env.REACT_APP_ENV === 'production' ||
            process.env.REACT_APP_ENV === 'leaguetech-production'
              ? 'production'
              : 'sandbox',
        },
      };
    case 'SET_CUSTOMER_INFO':
      return {
        ...state,
        customerInfo: { ...state.customerInfo, ...action.payload },
      };
    case 'SET_PAYMENT_LIST':
      return {
        ...state,
        paymentList: action.payload,
      };
    case 'SET_INSTALLMENTS_LIST':
      return {
        ...state,
        installmentsList: action.payload,
      };
    case 'SET_APPEARANCE_QUESTIONS':
      return {
        ...state,
        appearanceQuestions: action.payload,
      };
    case 'SET_EXAM_RESULT':
      return {
        ...state,
        examResult: action.payload,
      };
    case 'SET_PREVIOUS_ORDERS':
      return {
        ...state,
        previousOrders: action.payload,
      };
    case 'RESET_BUT_KEEP_TOKEN_LOGIN_INFO': {
      const { app, loginInfo } = state;
      return {
        app,
        loginInfo,
      };
    }
    case 'RESET_DATA_CONTEXT':
      return {};
    case 'RESET_ORDER_STATUS':
      const {
        app,
        paymentList,
        loginInfo: { dealerNo, empNo, extWsClass },
        customerInfo: {
          brand,
          capacity,
          imei,
          imeiServiceName,
          market_n,
          model,
          previousInsuranceNo,
          productType,
          invoiceDate,
        },
      } = state;
      return {
        app,
        paymentList,
        loginInfo: { dealerNo, empNo, extWsClass },
        customerInfo: {
          brand,
          capacity,
          imei,
          imeiServiceName,
          market_n,
          model,
          previousInsuranceNo,
          productType,
          invoiceDate,
        },
      };
    default:
      return state;
  }
};

const actions = {
  login:
    (dispatch) =>
    ({ userId, userPw }, callback) => {
      postReq(LEAGUE_LOGIN_URL, { userId, userPw }, (data) => {
        const {
          rtnObj: { ResponseCode, Attribute1, UserID, Attribute4, App, NewExtWs, ExtWsClass },
        } = data;

        if (ResponseCode === '1' && Attribute4) {
          dispatch({
            type: 'SET_LOGIN_INFO',
            payload: {
              dealerNo: Attribute1,
              empNo: UserID,
              insuranceSellerNo: Attribute4,
              canSellNewExt: NewExtWs,
              extWsClass: ExtWsClass,
              tokenLogin: false,
            },
          });
          dispatch({
            type: 'SET_APP_INFO',
            payload: App,
          });
        }

        if (callback) callback(data);
      });
    },
  loginByToken:
    (dispatch) =>
    ({ token }, callback) => {
      postReq(LEAGUE_LOGIN_BY_TOKEN_URL, { token }, (data) => {
        const {
          rtnObj: { ResponseCode, Attribute1, UserID, Attribute4, App, NewExtWs, ExtWsClass },
        } = data;

        if (ResponseCode === '1' && Attribute4) {
          dispatch({
            type: 'SET_LOGIN_INFO',
            payload: {
              dealerNo: Attribute1,
              empNo: UserID,
              insuranceSellerNo: Attribute4,
              canSellNewExt: NewExtWs,
              extWsClass: ExtWsClass,
              tokenLogin: true,
              token,
            },
          });
          dispatch({
            type: 'SET_APP_INFO',
            payload: App,
          });
        }

        if (callback) callback(data);
      });
    },
  setCustomerInfo: (dispatch) => (payload, callback) => {
    dispatch({ type: 'SET_CUSTOMER_INFO', payload });

    if (callback) callback();
  },
  setEmployeeInfo: (dispatch) => (payload, callback) => {
    dispatch({ type: 'SET_LOGIN_INFO', payload });

    if (callback) callback();
  },
  setTokenLogin: (dispatch) => (payload, callback) => {
    dispatch({ type: 'SET_LOGIN_INFO', payload });

    if (callback) callback();
  },
  setTokenAttempted: (dispatch) => (value, callback) => {
    dispatch({ type: 'SET_LOGIN_INFO', payload: { tokenAttempted: value } });

    if (callback) callback && callback();
  },
  resetOrderStatus: (dispatch) => () => {
    dispatch({ type: 'RESET_ORDER_STATUS' });
  },
  getMobileGuaranteeInfo: (dispatch) => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/getMobileGuaranteeInfo', payload, (data) => {
      const {
        rtnObj: { InsuranceList, ResponseCode },
      } = data;

      if (ResponseCode === '1') {
        dispatch({ type: 'SET_PAYMENT_LIST', payload: InsuranceList });
      }

      if (callback) callback(data);
    });
  },
  saveOrderInfo: (dispatch) => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/saveOrderInfo', payload, (data) => {
      const { responseCode, rtnObj } = data;

      if (responseCode === '000') {
        dispatch({ type: 'SET_CUSTOMER_INFO', payload: { orderId: rtnObj } });
      }

      if (callback) callback(data);
    });
  },
  uploadInsurePic: () => (payload, callback) => {
    postImageUploadFormData(ACEMUSE_API_URL + '/insureUploadPic', payload, (data) => {
      if (callback) callback(data);
    });
  },
  saveProfile: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/saveProfile', payload, (data) => {
      if (callback) callback(data);
    });
  },
  // Deprecated 2022/10/26
  // getExam: (dispatch) => (payload, callback) => {
  //   dispatch({
  //     type: 'SET_APPEARANCE_QUESTIONS',
  //     payload: appearanceQuestions.PROP_GROUPS,
  //   });

  //   if (callback)
  //     callback({ responseCode: '000', rtnObj: appearanceQuestions });
  // },
  setExamResult: (dispatch) => (payload, callback) => {
    dispatch({ type: 'SET_EXAM_RESULT', payload });

    if (callback) callback();
  },
  saveExamResult: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/savePropGroup', payload, (data) => {
      if (callback) callback(data);
    });
  },
  sendSMSMessage: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/sendSMSMessage', payload, (data) => {
      if (callback) callback(data);
    });
  },
  checkSMSCode: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/checkSmsCode', payload, (data) => {
      if (callback) callback(data);
    });
  },
  getInsuranceDocInfo: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/getInsuranceDocInfo', payload, (data) => {
      if (callback) callback(data);
    });
  },
  saveOrderInsurance: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/saveOrderInsurance', payload, (data) => {
      if (callback) callback(data);
    });
  },
  updateOrderInsurance: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/updateOrderInsurance', payload, (data) => {
      if (callback) callback(data);
    });
  },
  sendTapPayPrime: (dispatch) => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/sendTapPayPrime', payload, (data) => {
      const { responseCode, rtnObj } = data;

      if (responseCode === '002') {
        dispatch({
          type: 'SET_INSTALLMENTS_LIST',
          payload: rtnObj.Installments,
        });
      }

      if (callback) callback(data);
    });
  },
  checkBarcodePaid: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/checkBarcodePaid', payload, (data) => {
      if (callback) callback(data);
    });
  },
  checkImei: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/checkImei', payload, (data) => {
      if (callback) callback(data);
    });
  },
  // Deprecated? 2022/11/11
  checkAPTGValidation: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/aptgTnvalidator', payload, (data) => {
      if (callback) callback(data);
    });
  },
  checkBlacklist: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/blackListCheck', payload, (data) => {
      if (callback) callback(data);
    });
  },
  checkAPTGUserStatus: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/getAptgUserStatus', payload, (data) => {
      if (callback) callback(data);
    });
  },
  resetDataContext: (dispatch) => (payload, callback) => {
    if (payload && payload.keepTokenLoginInfo) {
      dispatch({ type: 'RESET_BUT_KEEP_TOKEN_LOGIN_INFO' });
    } else {
      dispatch({ type: 'RESET_DATA_CONTEXT' });
    }

    if (callback) callback();
  },
  uploadUserPic: () => (payload, callback) => {
    postImagesUploadFormData(ACEMUSE_API_URL + '/userUploadPic', payload, (data) => {
      if (callback) callback(data);
    });
  },
  updateCreditInstallment: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/updateCreditInstallment', payload, (data) => {
      if (callback) callback(data);
    });
  },
  getPreviousOrders: (dispatch) => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/getChangeOrderByDate', payload, (data) => {
      const { responseCode, rtnObj } = data;

      if (responseCode === '000') {
        dispatch({ type: 'SET_PREVIOUS_ORDERS', payload: rtnObj });
      }

      if (callback) callback(data);
    });
  },
  getToken: () => (callback) => {
    postReq(LEAGUE_API_URL + '/GetApiTokenAPTG.jsp', {}, callback);
  },
  checkBarcodeTx:
    () =>
    ({ barcode1, barcode2, barcode3, apiToken }, callback) => {
      postReq(
        LEAGUE_API_URL + '/QueryTxPaidByBarCodeAPTG.jsp',
        {
          BARCODE1: barcode1,
          BARCODE2: barcode2,
          BARCODE3: barcode3,
          API_TOKEN: apiToken,
        },
        callback
      );
    },
  checkUserStatus:
    () =>
    ({ userIMEI, userMobileNumber, apiToken }, callback) => {
      postReq(
        LEAGUE_API_URL + '/QueryUserStatusAPTG.jsp',
        {
          USER_IMEI: userIMEI,
          USER_MDN: userMobileNumber,
          API_TOKEN: apiToken,
        },
        callback
      );
    },
  getInsuranceInfo:
    () =>
    (
      { insuranceFee, insuranceName, orderId, employeeCode, paymentMethod, paymentType },
      callback
    ) => {
      postReq(
        LEAGUE_API_URL + '/SVCGetInsuranceDocInfo.jsp',
        {
          P1: insuranceFee,
          P2: insuranceName,
          P3: orderId,
          P4: employeeCode,
          P5: paymentMethod,
          P6: paymentType,
        },
        callback
      );
    },
  checkBaseInfo:
    () =>
    ({ imei, brand, model, capacity }, callback) => {
      postReq(
        LEAGUE_API_URL + '/SVCCheckBaseInfoNew.jsp',
        {
          IMEI: imei,
          BRAND: brand,
          MODEL: model,
          CAPACITY: capacity,
          MDATE: 'X',
        },
        callback
      );
    },
  getVirtualAccountInfo:
    () =>
    ({ orderId, insurancePrice }, callback) => {
      postReq(ACEMUSE_API_URL + '/getVirtualAccountInfo', { orderId, insurancePrice }, (data) => {
        if (callback) callback(data);
      });
    },
  updateVirtualAccount:
    () =>
    ({ orderId, virtualAccount, bankId }, callback) => {
      postReq(
        ACEMUSE_API_URL + '/updateVirtualAccount',
        { orderId, virtualAccount, bankId },
        (data) => {
          if (callback) callback(data);
        }
      );
    },
  // --- burglary insurance ---
  checkImeiAndIDCard: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/checkImeiAndIDCard', payload, (data) => {
      if (callback) callback(data);
    });
  },
  theftGetMobileGuaranteeInfo: (dispatch) => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/theftGetMobileGuaranteeInfo', payload, (data) => {
      const {
        rtnObj: { InsuranceList, ResponseCode },
      } = data;

      if (ResponseCode === '1') {
        dispatch({ type: 'SET_PAYMENT_LIST', payload: InsuranceList });
      }

      if (callback) callback(data);
    });
  },
  theftSaveOrderInfo: (dispatch) => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/theftSaveOrderInfo', payload, (data) => {
      const { responseCode, rtnObj } = data;

      if (responseCode === '000') {
        dispatch({ type: 'SET_CUSTOMER_INFO', payload: { orderId: rtnObj } });
      }

      if (callback) callback(data);
    });
  },
  theftGetInsuranceDocInfo: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/theftGetInsuranceDocInfo', payload, (data) => {
      if (callback) callback(data);
    });
  },
  theftSaveOrderInsurance: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/theftSaveOrderInsurance', payload, (data) => {
      if (callback) callback(data);
    });
  },
  // --- burglary insurance ---
  // --- extend new ---
  extCheckImei: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/extCheckImei', payload, (data) => {
      if (callback) callback(data);
    });
  },
  getMobileGuaranteeInfoExt: (dispatch) => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/getMobileGuaranteeInfoExt', payload, (data) => {
      const {
        rtnObj: { InsuranceList, ResponseCode },
      } = data;

      if (ResponseCode === '1') {
        dispatch({ type: 'SET_PAYMENT_LIST', payload: InsuranceList });
      }

      if (callback) callback(data);
    });
  },
  saveExtProfile: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/saveExtProfile', payload, (data) => {
      if (callback) callback(data);
    });
  },
  saveOrderExtension: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/saveOrderExtension', payload, (data) => {
      if (callback) callback(data);
    });
  },
  sendTapPayPrimeExt: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/sendTapPayPrimeExt', payload, (data) => {
      if (callback) callback(data);
    });
  },
  sendTapPayPrimeExt3D: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/sendTapPayPrimeExt3D', payload, (data) => {
      if (callback) callback(data);
    });
  },
  validation3DPayment: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/validation3DPayment', payload, (data) => {
      if (callback) callback(data);
    });
  },
  uploadUserPicExt: () => (payload, callback) => {
    postImagesUploadFormDataExt(ACEMUSE_API_URL + '/userUploadPicExt', payload, (data) => {
      if (callback) callback(data);
    });
  },
  sendNotification: () => (payload, callback) => {
    postReq(ACEMUSE_API_URL + '/sendNotification', payload, (data) => {
      if (callback) callback(data);
    });
  },
  // --- extend new ---
};

// const initialState = {};
const initialState =
  process.env.REACT_APP_ENV === 'staging' || process.env.REACT_APP_ENV === 'development'
    ? {
        app: {
          ApId: '13289',
          ApIdExt: '150998',
          ApKey: 'app_NXYNt6xDDVAiaa0EDT6Eo3KsVD8ZhVhSoaTCPYi6zAGtbzyEF8jojbk27cDx',
          ApKeyExt: 'app_zIcTdyIp6f2QSLDXmI0VYSXoz3woWVUIH636FDgILIGtAUYMHEOTqNXd0BHd',
          Env: 'sandbox',
        },
        loginInfo: {
          dealerNo: '008',
          empNo: 'GT0001',
          previousSign:
            'http://devweb.leaguetech.com.tw/agent_autography/728/912ab1ffd0d699458d4ead0e35b107e5eadf0b6c0fe6dd46a38dc94f154f4eec.jpg',
          empCode: 'S32G722518',
          empName: 'Richard',
        },
        customerInfo: {
          isSendOrderInsurance: false,
          brand: 'Apple',
          capacity: '256',
          market_n: 'iPhone SE 2020',
          model: 'iPhone12,8',
          imei: '123456789012347',
          productType: 'MOB',
          orderId: 17782,
          // base info
          payType: 'installment',
          insurancePrice: '198',
          serviceName: '智慧保鏢',
          swapPrice: '2000',
          validPeriod: '24',
          fromDate: '2022/09/23',
          toDate: '2024/09/22',
          periodType: 'M',
          paymentText: '月繳(24期)',
          // doc info
          repairTarget: '限台金馬地區亞太電信',
          phonePrice: '7777',
          insuranceNo: 'APTMB1000000177',
          repairCount: '0',
          // client info
          birthday: '1992-09-13',
          phone: '0963018999',
          email: 'test@test.com',
          city: '嘉義縣',
          zip_code: '602',
          district: '番路鄉',
          restAddress: 'Test Rd, No 1',
          address: '602嘉義縣番路鄉Test Rd, No 1',
          name: 'Tester',
          id: 'A123456789',
          otherNationChecked: false,
          nation: null,
          previousInsuranceNo: '',
          // bank transfer info
          bankId: '822',
          bankName: '台新銀行',
          virtualAccount: '123456789012',
          paymentExpireDate: '2022/10/31',
        },
        paymentList: [
          {
            PeriodType: 'M',
            PaymentExecTimes: '24',
            ReturnRecURL: 'https://devap.leaguetech.com.tw/recins/rec_payment_result',
            WarrantyMonth: '24',
            PaymentTypeName: '月繳(24期)',
            SwapPrice: '2000',
            PaymentType: 'installment',
            InsuranceName: '智慧保鏢',
            InsurancePrice: '198',
            InsuranceStartDate: '2024/10/16',
            InsuranceEndDate: '2026/10/16',
          },
          {
            PeriodType: 'M',
            PaymentExecTimes: '24',
            ReturnRecURL: '',
            WarrantyMonth: '24',
            PaymentTypeName: '電信帳單(24期)',
            SwapPrice: '2000',
            PaymentType: 'tel_bill',
            InsuranceName: '智慧保鏢',
            InsurancePrice: '198',
            InsuranceStartDate: '2024/10/16',
            InsuranceEndDate: '2026/10/16',
          },
          {
            PeriodType: '',
            PaymentExecTimes: '1',
            ReturnRecURL: '',
            WarrantyMonth: '12',
            PaymentTypeName: '現金(1年)',
            SwapPrice: '2000',
            PaymentType: 'cash',
            InsuranceName: '智慧保鏢',
            InsurancePrice: '2370',
            InsuranceStartDate: '2024/10/16',
            InsuranceEndDate: '2025/10/16',
          },
          {
            PeriodType: '',
            PaymentExecTimes: '1',
            ReturnRecURL: '',
            WarrantyMonth: '12',
            PaymentTypeName: '不分期(1年)',
            SwapPrice: '2000',
            PaymentType: 'credit',
            InsuranceName: '智慧保鏢',
            InsurancePrice: '2370',
            InsuranceStartDate: '2024/10/16',
            InsuranceEndDate: '2025/10/16',
          },
        ],
        previousOrders: [
          {
            orderId: '18078',
            tradeDate: '2022-10-19 11:57:59',
            name: 'test',
            phone: '0912345678',
            policyNumber: 'APTMB1000000256',
            serviceName: '智慧保鏢',
            model: 'Desire 12',
            imei: '123',
          },
          {
            orderId: '18157',
            tradeDate: '2022-10-26 17:00:04',
            name: 'Tester',
            phone: '0963018999',
            policyNumber: 'APTYB2000000279',
            serviceName: '智慧保鏢',
            model: 'iPad Air (2019)',
            imei: '123123',
          },
        ],
        installmentsList: [
          {
            OptionsName: '不分期',
            OptionsKey: 1,
          },
          {
            OptionsName: '$1500 x 3期0利率',
            OptionsKey: 3,
          },
          {
            OptionsName: '$750 x 6期0利率',
            OptionsKey: 6,
          },
          {
            OptionsName: '$500 x 9期0利率',
            OptionsKey: 9,
          },
          {
            OptionsName: '$375 x 12期0利率',
            OptionsKey: 12,
          },
        ],
      }
    : {};

export const { Context, Provider } = createDataContext(reducer, actions, initialState);
